import {Component} from '@angular/core';
import {Events, NavController, NavParams} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {ServicesPage} from "../services/services";
import {TabsServiceProvider} from "../../providers/tabs-service/tabs-service";

/**
 * Generated class for the CancelledBookingsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-cancelled-bookings',
    templateUrl: 'cancelled-bookings.html',
})
export class CancelledBookingsPage {

    errors: {};
    loading: boolean;
    tuid: any;
    shop: any;
    barber: any;
    bookings: any;
    fromLobby: boolean;
    fromStaffPanel: boolean;
    byStaff: boolean;
    guestUser: any = null;

    constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public events: Events,
      private http: HttpClient,
      private apiErrorHandler: ApiErrorHandlerProvider,
      private tabsService: TabsServiceProvider
    ) {
        this.tabsService.hide();
        this.shop = navParams.get('shop');
        this.barber = navParams.get('barber');
        this.bookings = this.barber.todays_cancelled_bookings;
        this.fromLobby = navParams.get('fromLobby') ? true : false;
        this.fromStaffPanel = navParams.get('fromStaffPanel') ? true : false;
        this.byStaff = navParams.get('byStaff') ? true : false;
        this.guestUser = navParams.get('guestUser');

        this.events.subscribe('booking:badge+', () => {
            this.loading = true;

            this.getShop().then((shop: any) => {
                this.shop = shop;
                shop.users.forEach((user, index) => {
                    if (user.id === this.barber.id) {
                        this.bookings = user.todays_cancelled_bookings;
                        this.appendServicesToBooking().then(() => {
                            this.loading = false;
                        })
                    }
                });

            })
        });
    }

    ionViewDidLoad() {
        this.loading = true;
        this.appendServicesToBooking().then(() => {
            this.loading = false;
        })
    }

    appendServicesToBooking() {
        let count = this.bookings.length - 1;
        return new Promise((resolve, reject) => {
            this.bookings.forEach((booking, index) => {
                this.getAvailableDurationForCancelledBooking(booking).then((availableDuration) => {
                    booking.available_duration = availableDuration;
                    this.http.get(`/team/${this.shop.id}/members/${this.barber.id}/services?available_duration=${availableDuration}`)
                        .subscribe((services: any) => {
                            booking.full_services = services;
                            if (count === index) {
                                resolve(true)
                            }
                        }, (error) => {
                            reject(error);
                            this.errors = error;
                            this.apiErrorHandler.handleError(error)
                        });
                })
            })
        })
    }

    getAvailableDurationForCancelledBooking(booking) {
        return new Promise((resolve, reject) => {
            let serviceIds = [];

            booking.services.forEach((service) => {
                serviceIds.push(service.service_id);
            });

            this.http.get(`/bookings/${booking.id}/services/total-duration`)
                .subscribe((duration: any) => {
                    resolve(duration);
                }, (error) => {
                    reject(error);
                    this.errors = error;
                    this.apiErrorHandler.handleError(error)
                });
        })
    }

    openServices(booking = null) {
        this.navCtrl.push(ServicesPage, {
            barber: this.barber,
            shop: this.shop,
            booking: booking,
            fromLobby: this.fromLobby,
            fromStaffPanel: this.fromStaffPanel,
            byStaff: this.byStaff,
            guestUser: this.guestUser
        })
    }

    getShop() {
        return new Promise((resolve, reject) => {
            this.http.get(`/teams/${this.shop.id}`)
                .subscribe((shop: any) => {
                    return resolve(shop);
                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    return reject();
                }, () => {

                });
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/cancelled-bookings/cancelled-bookings.ts